// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"3e787d51","164":"e8f458df","254":"98d0afbd","301":"83f7f2cc","444":"9a2b7778","453":"c8f333e4","721":"f035319b"}[chunkId] + ".chunk.js";
};